import { isBlissTenantSlug } from './hostTenants'

function normalizeHost(hostname?: string | null): string {
  return (hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '')).toLowerCase()
}

/** Hostname for the Bliss Basic product line (standardized models, API handoff). */
export function isBlissBasicHost(hostname?: string | null): boolean {
  const h = normalizeHost(hostname)
  return h === 'basic.blissbunkbeds.com' || h.startsWith('basic.')
}

/** Master Control / company admin — not the white-label partner catalog studio. */
export function isBlissAdminHost(hostname?: string | null): boolean {
  const h = normalizeHost(hostname)
  return h === 'admin.blissbunkbeds.com' || h.startsWith('admin.')
}

export const BLISS_BASIC_PUBLIC_ORIGIN = 'https://basic.blissbunkbeds.com'

export const BLISS_CUSTOM_FUNNEL_URL = 'https://quote.blissbunkbeds.com'

/** Dedicated route — never loads Master Control Center chrome. */
export const BLISS_BASIC_BACK_OFFICE_PATH = '/basic-admin'

export {
  isBlissBasicPartnerTenant,
  shouldUseBlissBasicBackOffice,
  tenantUsesBlissBasicBackOffice,
} from '../utils/blissBasicBackOfficeGate'

// Re-export for callers that only imported from hostTenants pattern
export { isBlissTenantSlug }
